import React, { createContext, useState } from 'react';

export const defaultAppState = {
  showMenu: false,
};

export const AppContext = createContext();

const AppContextProvider = ({ children }) => {
  const [appState, setAppState] = useState({
    ...defaultAppState,
  });
  return (
    <AppContext.Provider value={{ ...appState, setAppState }}>
      {children}
    </AppContext.Provider>
  );
};

export default AppContextProvider;
